import { Service } from './baseService';

export const getDriverPortalInstanceService = async (hostname) => {
    const response = await Service.get(`/driver-portal-instances/${hostname}`);
    return response.data;
};
